import React, { useEffect, useState } from 'react';
export default function Connectivity() {
  const [online, setOnline] = useState(navigator.onLine);
  const [update, setUpdate] = useState(false);
  useEffect(() => {
    const changed = () => setOnline(navigator.onLine);
    window.addEventListener('online', changed); window.addEventListener('offline', changed);
    let registration: ServiceWorkerRegistration | undefined;
    const check = () => setUpdate(!!registration?.waiting);
    const installing = () => registration?.installing?.addEventListener('statechange', check);
    navigator.serviceWorker?.getRegistration().then(r => { registration = r; check(); r?.addEventListener('updatefound', installing); });
    return () => { window.removeEventListener('online', changed); window.removeEventListener('offline', changed); registration?.removeEventListener('updatefound', installing); };
  }, []);
  return <>{!online && <div className="cs-connectivity" role="status">You’re offline. Keep this page open to retain edits. Submissions require a connection; nothing will be sent automatically.</div>}
    {update && <div className="cs-connectivity" role="status">An update is ready. Save your work, then close all Cafe Ops tabs and reopen the app.</div>}</>;
}
